<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="640px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="100px">
      <el-form-item
        label="姓名："
        prop="userId">
        <el-input
          v-if="!info.courseCertId"
          v-model="info.userName"
          readonly>
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="selectPerson"></el-button>
        </el-input>
        <span v-else>{{ info.userName }}</span>
      </el-form-item>
      <el-form-item label="手机号：">{{ info.mobilePhone }}</el-form-item>
      <el-form-item
        label="证书编号："
        prop="certNo">
        <el-input v-model="info.certNo"></el-input>
      </el-form-item>
      <el-form-item
        label="过期时间："
        prop="expireDate">
        <el-date-picker
          v-model="info.expireDate"
          :editable="false"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="证书等级："
        prop="level">
        <el-select
          v-model="info.level"
          placeholder="请选择">
          <el-option
            v-for="item in levels"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="证书文件："
        prop="certFile">
        <upload-with-crop
          v-model="info.certFile"
          :isLt2M="2048"
          :limit="1"
          :autoCropWidth="160"
          :autoCropHeight="160"></upload-with-crop>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </span>
    <user-select-modal
      ref="select"
      :callback="userCallback" />
  </el-dialog>
</template>
<script>
import UploadWithCrop from '../../components/public/upload-with-crop.vue'
import UserSelectModal from '../luxury-users/user-select-modal.vue'
export default {
  name: 'EditCertModal',
  components: { UploadWithCrop, UserSelectModal },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      info: {
        courseCertId: null,
        userId: null,
        userName: '',
        mobilePhone: '',
        idCertNo: '',
        courseScoreId: null,
        certNo: '',
        level: 1,
        // status: 1,
        expireDate: null,
        certFile: []
      },
      levels: [
        { label: '一级', value: 1 },
        { label: '中级', value: 2 },
        { label: '高级', value: 3 }
      ],
      rules: {
        userId: [
          { required: true, message: '请选择人员', trigger: 'blur' }
        ],
        certNo: [
          { required: true, message: '请输入证书编号', trigger: 'blur' }
        ],
        expireDate: [
          { required: true, message: '请选择过期时间', trigger: 'change' }
        ],
        certFile: [
          { required: true, message: '请上传证书文件', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    title() {
      const courseCertId = this.info.courseCertId
      return (courseCertId ? '编辑' : '新增') + '证书'
    },
    serviceProvinceCode() {
      return this.info.area[0] || null
    },
    serviceCityCode() {
      return this.info.area[1] || null
    }
  },
  methods: {
    selectPerson() {
      this.$refs.select.fetch()
    },
    userCallback(row) {
      console.log(row)
      this.info.userId = row.userId
      this.info.userName = row.userName
      this.info.mobilePhone = row.mobilePhone
      this.info.idCertNo = row.idCertNo
    },
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.info = {
        courseCertId: null,
        userId: null,
        userName: '',
        mobilePhone: '',
        idCertNo: '',
        courseScoreId: null,
        certNo: '',
        level: 1,
        // status: 1,
        expireDate: null,
        certFile: []
      }
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.info.courseCertId
            ? 'updatecoursecert'
            : 'addcoursecert'
          this.$store.dispatch(`account/${dispatch}`, {
            payload: {
              ...this.info,
              expireDate: +this.info.expireDate,
              certFile: this.info.certFile.map(i => i.url).join(',')
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.$message.success('保存成功')
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    add() {
      this.toggleModal(true)
    },
    update(options = {}) {
      this.info = {
        ...this.info,
        ...options
      }
      this.toggleModal(true)
    }
  }
}
</script>
